export default "__VITE_ASSET__uCguE7Z___"